module.exports = __webpack_public_path__ + "media/content-creator/mobile-health-1-bb6e3037.png";